import { useEffect, useState } from 'react'
import cookie from 'js-cookie'

import { UserStore } from 'src/store/UserStore'
import { sendMessageToExt } from 'src/utils/config'
import { ACTION_LOGIN } from 'src/utils/actions'
import { Referrer } from 'src/utils/localStore'

export const useAuth = () => {
  const [dataLoaded, setDataLoaded] = useState(false)

  useEffect(() => {
    const init = async () => {
      const data = {
        referrer: document.referrer,
        entry_url: window.location.href,
      }

      const AUTHORIZATION = cookie.get(`token`)

      if (AUTHORIZATION) {
        try {
          await UserStore.setAndFetchUser(AUTHORIZATION)
          sendMessageToExt(ACTION_LOGIN)
          Referrer.remove()
        } catch (error) {
          console.error(error)
        }
      } else {
        Referrer.safeRef(data)
      }

      setDataLoaded(true)
    }

    init()
  }, [])

  return [dataLoaded]
}
